import { ApiConfigActions, AuthConfigActions, AuthConfigReducer } from '@pwbapps/reduxcore';
import { Actions, CommandActions, DocumentActions, FETCH_USERS, FETCH_INTERNAL_USERS, FETCH_EXTERNAL_USERS, ADD_PROJECT_USER, REMOVE_PROJECT_USER, DELETE_EXOD_USER, RESET_AND_CLOSE_MODAL, SAVE_USERS, SAVE_NEW_EXTERNAL_USER, CHECK_EXTERNAL_USER, DOWNLOAD_USERS } from '../../actions/administrationModal';
import { getSelectedProjectId } from '../../reducers/project';
import { getCanManageUsers, getCanCreateProject, getProjectRoles } from '../../reducers/initialization';
import { getIncludeDeleted, getProjectUsers, getUsersBusy, getUsersMutationVersion, getUsersRefreshAfterRoles, getOpenModal, getInternalFilter, getExternalFilter, getInternalAppRoles, getExternalAppRoles, getInternalEditUsers, getExternalEditUsers } from '../../reducers/administrationModal';
import { CommandActions as InitializationCommandActions, SET_VALUE as SET_INITIALIZATION_VALUE } from '../../actions/initialization';
import { configuration } from '../../../configuration';
import { EXTERNAL_ROLES, INTERNAL_ROLES, isValidUserObjectId, getProviderUserObjectId, Tenant } from '../../../models/projectRoles';
import { LOAD_OBJECTS_AND_SET_PROJECT } from '../../actions/project';
import { AppUser, ExternalUserForm, Role, mapAdministrationUsers } from '../../../models/administration';
import { getSelectedProjectCodeword } from '../../selectors/project';
import { getStakeHolders } from '../../reducers/sharedData';
import { getInternalUsersUrl, getExternalUsersUrl, newExternalUserUrl, dowloadUsersUrl } from '../../../utils/administrationUrls';
import { CommandActions as LoaderActions } from '../../actions/loader';
import { CommandActions as NotifyActions, EventActions as NotifyEvents } from '../../actions/notifySettings';
import { CommandActions as ModalActions, DocumentActions as ModalDocuments } from '../../actions/modal';
import { getGenericModal } from '../../selectors/ui';
import { isProdEnv, validateEmail } from '../../../utils/functions';
import { DocumentActions as NotificationActions } from '../../actions/notification';
import { MessageBarType } from '@fluentui/react';
import saveAs from 'file-saver';

let requestId = 0;
const features = [FETCH_USERS, FETCH_INTERNAL_USERS, FETCH_EXTERNAL_USERS, ADD_PROJECT_USER, REMOVE_PROJECT_USER, DELETE_EXOD_USER, SAVE_USERS, SAVE_NEW_EXTERNAL_USER, CHECK_EXTERNAL_USER, DOWNLOAD_USERS];

export const administrationModalMiddlewareHistory = (history: any) => administrationModalMiddleware(history);

export const administrationModalMiddleware = (history: any) => ({dispatch, getState}: {dispatch: any, getState: any}) => (next: any) => (action: Actions | ApiConfigActions.EventActions | AuthConfigActions.Actions | {type: typeof LOAD_OBJECTS_AND_SET_PROJECT}) => {
    next(action);
    const setValue = (name: string, value?: any) => next(DocumentActions.setValue({name, value}));
    const projectId = getSelectedProjectId(getState());
    const usersUrl = `${configuration.api_endpoint}/Projects/${projectId}/Users`;
    const setBusy = (busy: boolean) => {
        setValue('busy', busy);
        next(LoaderActions.setLoading({feature: 'administration', loading: busy}));
    };
    const currentId = () => {
        const account = AuthConfigReducer.getAccount(getState());
        const claims = account && account.idTokenClaims as any;
        const me = getProjectRoles(getState());
        return me && getProviderUserObjectId(me.tenant, claims);
    };
    const isSelf = (user: {tenant?: Tenant, userObjectId?: string}) => {
        const me = getProjectRoles(getState());
        const id = currentId();
        return !!me && user.tenant === me.tenant && !!id && !!user.userObjectId && user.userObjectId.toLowerCase() === id.toLowerCase();
    };
    const roles = (codes: string[]): Role[] => ['NONE', ...codes].map(code => ({id: code, name: code as Role['name'], azureName: code}));
    const publishUsers = (tenant: Tenant, directory: any[]) => {
        const internal = tenant === 'internal';
        const filter = (internal ? getInternalFilter(getState()) : getExternalFilter(getState())) || '';
        const edits = internal ? getInternalEditUsers(getState()) : getExternalEditUsers(getState());
        const options = internal ? getInternalAppRoles(getState()) : getExternalAppRoles(getState());
        const stakeholders = getStakeHolders(getState()) || [];
        const users = mapAdministrationUsers(directory, getProjectUsers(getState()), tenant, options).map(user => {
            const edited = edits.find(item => item.rowKey === user.rowKey);
            const stakeholder = stakeholders.find(item => item.companyName === user.company);
            return {...user, ...edited, isSelf: isSelf(user), stakeHolderId: stakeholder && stakeholder.stakeHolderId};
        }).filter(user => [user.email, user.name].some(value => value && value.toLowerCase().includes(filter.toLowerCase())));
        setValue(internal ? 'internalAppUsers' : 'externalAppUsers', users);
        next(internal ? LoaderActions.setLoadingInternal({feature: 'administration', loading: false}) : LoaderActions.setLoadingExternal({feature: 'administration', loading: false}));
        if (users.length && isProdEnv()) dispatch(NotifyActions.fetchUsersRules({users, isExternal: !internal}));
    };
    const request = (feature: string, method: string, url: string, body?: any, context: any = {}) => {
        dispatch(ApiConfigActions.CommandActions.apiTokenRequest({request: {method, url, body, feature, returnObject: {projectId, requestId, ...context}}}));
    };
    const finishSave = (context: any) => {
        setBusy(false);
        setValue('internalEditedUsers', []);
        setValue('externalEditedUsers', []);
        setValue('mutationVersion', getUsersMutationVersion(getState()) + 1);
        if (context.newExternal) dispatch(ModalActions.closeModal({id: 'newExternalUser'}));
        if (isProdEnv()) {
            [false, true].forEach(isExternal => {
                const users = (context.editedUsers || []).filter((user: AppUser) => (user.tenant === 'external') === isExternal);
                const kept = users.filter((user: AppUser) => user.role && user.role.name !== 'NONE');
                const removed = users.filter((user: AppUser) => user.role && user.role.name === 'NONE');
                const addedNotifications = kept.filter((user: AppUser) => user.notifications && user.notifications.some(notification => !notification.eventTypeRuleId));
                const removedNotifications = kept.filter((user: AppUser) => user.notificationsToBeRemoved && user.notificationsToBeRemoved.length);
                const removedUserNotifications = removed.filter((user: AppUser) => user.notifications && user.notifications.length && !getProjectUsers(getState()).some(assignment => !assignment.isDeleted && assignment.tenant === user.tenant && assignment.userObjectId.toLowerCase() === user.userObjectId.toLowerCase()));
                if (addedNotifications.length) dispatch(NotifyEvents.saveMultipleRules({users: addedNotifications, isExternal}));
                if (removedNotifications.length) dispatch(NotifyEvents.deleteMultipleRules({users: removedNotifications, all: false, isExternal}));
                if (removedUserNotifications.length) dispatch(NotifyEvents.deleteMultipleRules({users: removedUserNotifications, all: true, isExternal}));
            });
        }
        next(NotificationActions.setNotificationStatus({name: 'administration', show: true, type: MessageBarType.success, message: context.newExternal ? 'User created successfully' : 'User permissions saved successfully'}));
        setValue('refreshAfterRoles', true);
        dispatch(InitializationCommandActions.fetchProjectRoles());
    };
    const runQueue = (operations: any[], context: any) => {
        if (!operations.length) { finishSave(context); return; }
        const [operation, ...remaining] = operations;
        request(SAVE_USERS, operation.method, operation.url, operation.body, {...context, operation, remaining});
    };
    const assignCreatedUser = (form: ExternalUserForm, id: string) => {
        if (!isValidUserObjectId(id)) {
            setBusy(false);
            setValue('error', 'B2C did not return a valid user Object ID. No role was assigned.');
            return;
        }
        next(ModalDocuments.setContextItemProperty({id: 'newExternalUser', name: 'userObjectId', value: id}));
        const stakeholder = (getStakeHolders(getState()) || []).find(item => item.companyName === form.company);
        const user = {...form, tenant: 'external' as Tenant, id, userObjectId: id, stakeHolderId: stakeholder && stakeholder.stakeHolderId};
        runQueue([{method: 'POST', url: usersUrl, body: {tenant: 'external', userObjectId: id, roleCode: form.role.name, email: form.email, company: form.company}}], {newExternal: true, editedUsers: [user]});
    };

    switch (action.type) {
        case SET_INITIALIZATION_VALUE:
            if (action.payload.name === 'rolesLoading' && action.payload.value === false && getUsersRefreshAfterRoles(getState())) {
                setValue('refreshAfterRoles', false);
                if (getCanManageUsers(getState())) dispatch(CommandActions.fetchUsers({}));
            }
            break;
        case RESET_AND_CLOSE_MODAL:
        case LOAD_OBJECTS_AND_SET_PROJECT:
        case AuthConfigActions.LOGOUT:
            requestId++;
            setValue('openModal', false);
            setValue('projectUsers', []);
            setBusy(false);
            setValue('error');
            setValue('refreshAfterRoles', false);
            ['internalAppUsers', 'externalAppUsers', 'internalEditedUsers', 'externalEditedUsers'].forEach(name => setValue(name, []));
            next(LoaderActions.setLoadingInternal({feature: 'administration', loading: false}));
            next(LoaderActions.setLoadingExternal({feature: 'administration', loading: false}));
            break;

        case FETCH_INTERNAL_USERS:
        case FETCH_EXTERNAL_USERS: {
            if (!projectId || !getCanManageUsers(getState())) return;
            const internal = action.type === FETCH_INTERNAL_USERS;
            next(internal ? LoaderActions.setLoadingInternal({feature: 'administration', loading: true}) : LoaderActions.setLoadingExternal({feature: 'administration', loading: true}));
            const codeword = (getSelectedProjectCodeword(getState()) || '').replace(/\s/g, '');
            const url = internal ? getInternalUsersUrl(codeword, getInternalFilter(getState())) : getExternalUsersUrl(codeword, getExternalFilter(getState()));
            request(action.type, 'GET', url);
            break;
        }

        case SAVE_USERS: {
            if (!projectId || !getCanManageUsers(getState()) || getUsersBusy(getState())) return;
            const edits = [...getInternalEditUsers(getState()), ...getExternalEditUsers(getState())];
            const operations: any[] = [];
            for (const user of edits) {
                if (isSelf(user) || !isValidUserObjectId(user.userObjectId)) {
                    setValue('error', 'A valid provider Object ID is required and you cannot change your own roles.');
                    return;
                }
                const allowed = user.tenant === 'internal' ? INTERNAL_ROLES : EXTERNAL_ROLES;
                if (user.role && user.role.name !== 'NONE' && !allowed.includes(user.role.name)) {
                    setValue('error', 'Role not allowed for this tenant.');
                    return;
                }
                const original = getProjectUsers(getState()).find(item => item.projectUserRoleId === user.projectUserRoleId && item.tenant === user.tenant && item.userObjectId.toLowerCase() === user.userObjectId.toLowerCase());
                const code = user.role && user.role.name;
                if (code && code !== 'NONE' && (!original || original.roleCode !== code)) {
                    const exists = getProjectUsers(getState()).some(item => !item.isDeleted && item.tenant === user.tenant && item.userObjectId.toLowerCase() === user.userObjectId.toLowerCase() && item.roleCode === code);
                    if (!exists) operations.push({method: 'POST', url: usersUrl, body: {tenant: user.tenant, userObjectId: user.userObjectId, roleCode: code, email: user.email, displayName: user.name, ...(user.tenant === 'external' && user.company ? {company: user.company} : {})}});
                }
                if (original && code && original.roleCode !== code) operations.push({method: 'DELETE', url: `${usersUrl}/${original.projectUserRoleId}`});
            }
            if (!edits.length) return;
            requestId++;
            setValue('error');
            setBusy(true);
            runQueue(operations, {editedUsers: edits});
            break;
        }

        case SAVE_NEW_EXTERNAL_USER: {
            if (!projectId || !getCanManageUsers(getState()) || getUsersBusy(getState())) return;
            const modal = getGenericModal('newExternalUser')(getState());
            const form = modal && modal.contextItem as ExternalUserForm;
            if (!form) return;
            const errors = {
                email: !form.email ? 'This field is mandatory' : !validateEmail(form.email) ? 'Invalid email format' : undefined,
                company: !form.company ? 'This field is mandatory' : undefined,
                country: !form.country ? 'This field is mandatory' : undefined,
                role: !form.role || !EXTERNAL_ROLES.includes(form.role.name) ? 'This field is mandatory' : undefined
            };
            next(ModalDocuments.setContextItemProperty({id: 'newExternalUser', name: 'errors', value: errors}));
            if (Object.values(errors).some(Boolean)) return;
            requestId++;
            setBusy(true);
            setValue('error');
            if (form.userObjectId) assignCreatedUser(form, form.userObjectId);
            else request(CHECK_EXTERNAL_USER, 'GET', getExternalUsersUrl((getSelectedProjectCodeword(getState()) || '').replace(/\s/g, ''), form.email), undefined, {form});
            break;
        }

        case DOWNLOAD_USERS:
            if (!projectId || !getCanManageUsers(getState()) || getUsersBusy(getState())) return;
            requestId++;
            setBusy(true);
            dispatch(ApiConfigActions.CommandActions.apiTokenRequest({request: {method: 'POST', url: dowloadUsersUrl(), headers: [{name: 'Accept', value: 'application/octet-stream'}], responseType: 'arraybuffer', body: {projectIds: [getSelectedProjectCodeword(getState())], fileName: `${getSelectedProjectCodeword(getState())}_Users`}, feature: DOWNLOAD_USERS, returnObject: {projectId, requestId}}}));
            break;

        case FETCH_USERS:
        case ADD_PROJECT_USER:
        case REMOVE_PROJECT_USER:
        case DELETE_EXOD_USER: {
            if (!projectId || !getCanManageUsers(getState())) return;
            if (getUsersBusy(getState()) && action.type !== FETCH_USERS) return;
            const me = getProjectRoles(getState());
            const account = AuthConfigReducer.getAccount(getState());
            const claims = account && account.idTokenClaims as any;
            const currentId = getProviderUserObjectId(me.tenant, claims);
            let method = 'GET';
            let url = usersUrl;
            let body: any;
            if (action.type === FETCH_USERS) {
                next(CommandActions.setInternalRoles({value: roles(INTERNAL_ROLES)}));
                next(CommandActions.setExternalRoles({value: roles(EXTERNAL_ROLES)}));
                const includeDeleted = action.payload.includeDeleted === undefined ? getIncludeDeleted(getState()) : action.payload.includeDeleted;
                setValue('includeDeleted', includeDeleted);
                if (action.payload.openModal) setValue('openModal', true);
                setValue('projectUsers', []);
                url += `?includeDeleted=${includeDeleted}`;
            } else if (action.type === ADD_PROJECT_USER) {
                const user = action.payload.user;
                const roles = user.tenant === 'internal' ? INTERNAL_ROLES : EXTERNAL_ROLES;
                if (!['internal', 'external'].includes(user.tenant) || !roles.includes(user.roleCode)) return;
                const userObjectId = typeof user.userObjectId === 'string' ? user.userObjectId.trim() : undefined;
                if (!isValidUserObjectId(userObjectId)) {
                    setValue('error', 'A valid provider Object ID is required.');
                    return;
                }
                if (user.tenant === me.tenant && currentId && userObjectId.toLowerCase() === currentId.toLowerCase()) {
                    setValue('error', 'You cannot assign roles to yourself.');
                    return;
                }
                method = 'POST';
                body = {tenant: user.tenant, userObjectId, roleCode: user.roleCode, email: user.email, displayName: user.displayName, ...(user.tenant === 'external' && user.company ? {company: user.company} : {})};
            } else {
                const user = getProjectUsers(getState()).find(item => action.type === REMOVE_PROJECT_USER ? item.projectUserRoleId === action.payload.projectUserRoleId : item.exodUserId === action.payload.exodUserId);
                if (!user || (user.tenant === me.tenant && currentId && user.userObjectId.toLowerCase() === currentId.toLowerCase())) return;
                method = 'DELETE';
                if (action.type === DELETE_EXOD_USER) {
                    if (!getCanCreateProject(getState())) return;
                    url = `${configuration.api_endpoint}/Admin/Users/${user.exodUserId}`;
                } else {
                    if (user.isDeleted) return;
                    url += `/${user.projectUserRoleId}`;
                }
            }
            setBusy(true);
            setValue('error');
            dispatch(ApiConfigActions.CommandActions.apiTokenRequest({request: {method, url, body, feature: action.type, returnObject: {projectId, requestId: ++requestId}}}));
            break;
        }

        case ApiConfigActions.API_SUCCESS:
        case ApiConfigActions.API_ERROR: {
            if (!features.includes(action.meta.feature)) break;
            const request = action.meta.returnObject;
            if (!request || request.requestId !== requestId) break;
            if (![SAVE_USERS, SAVE_NEW_EXTERNAL_USER, CHECK_EXTERNAL_USER].includes(action.meta.feature) || action.type === ApiConfigActions.API_ERROR) setBusy(false);
            if (request.projectId !== projectId) break;
            if (action.type === ApiConfigActions.API_ERROR) {
                const error = action.payload as any;
                let problem = error && (error.data || (error.response && error.response.data) || error);
                if (typeof problem === 'string') {
                    try { problem = JSON.parse(problem); } catch { problem = {message: problem}; }
                }
                setValue('error', (problem && (problem.detail || problem.title || problem.message)) || 'Operation failed. Please retry.');
                if (action.meta.feature === FETCH_INTERNAL_USERS) next(LoaderActions.setLoadingInternal({feature: 'administration', loading: false}));
                if (action.meta.feature === FETCH_EXTERNAL_USERS) next(LoaderActions.setLoadingExternal({feature: 'administration', loading: false}));
            } else if (action.meta.feature === FETCH_USERS) {
                setValue('projectUsers', action.payload || []);
                if (getOpenModal(getState())) {
                    publishUsers('internal', []);
                    publishUsers('external', []);
                    dispatch(CommandActions.fetchInternalUsers());
                    dispatch(CommandActions.fetchExternalUsers());
                }
            } else if (action.meta.feature === FETCH_INTERNAL_USERS || action.meta.feature === FETCH_EXTERNAL_USERS) {
                const directory = Array.isArray(action.payload) ? action.payload : (action.payload && action.payload.value) || [];
                publishUsers(action.meta.feature === FETCH_INTERNAL_USERS ? 'internal' : 'external', directory);
            } else if (action.meta.feature === CHECK_EXTERNAL_USER) {
                const directory = Array.isArray(action.payload) ? action.payload : (action.payload && action.payload.value) || [];
                const form = request.form as ExternalUserForm;
                if (directory.some(user => String(user.email || user.mail || '').toLowerCase() === form.email.toLowerCase())) {
                    setBusy(false);
                    next(ModalDocuments.setContextItemProperty({id: 'newExternalUser', name: 'errors', value: {...form.errors, email: 'This email is already used'}}));
                } else {
                    dispatch(ApiConfigActions.CommandActions.apiTokenRequest({request: {method: 'POST', url: newExternalUserUrl(form), feature: SAVE_NEW_EXTERNAL_USER, returnObject: {...request, form}}}));
                }
            } else if (action.meta.feature === SAVE_NEW_EXTERNAL_USER) {
                const result = action.payload;
                const id = result && (result.userObjectId || result.objectId || result.idUser || result.id);
                assignCreatedUser(request.form, id);
            } else if (action.meta.feature === SAVE_USERS) {
                const operation = request.operation;
                if (operation.method === 'POST' && action.payload && action.payload.projectUserRoleId) setValue('projectUsers', [...getProjectUsers(getState()), action.payload]);
                if (operation.method === 'DELETE') setValue('projectUsers', getProjectUsers(getState()).filter(item => `${usersUrl}/${item.projectUserRoleId}` !== operation.url));
                runQueue(request.remaining, request);
            } else if (action.meta.feature === DOWNLOAD_USERS) {
                saveAs(new Blob([action.payload]), `${getSelectedProjectCodeword(getState())}_Users.xlsx`);
            } else {
                setValue('mutationVersion', getUsersMutationVersion(getState()) + 1);
                setValue('refreshAfterRoles', true);
                dispatch(InitializationCommandActions.fetchProjectRoles());
            }
            break;
        }
    }
};